// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Yh-z","sponsoredTooltipWrapper":"Zh-z","sponsoredTooltip":"_h-z","newCard":"ai-z"};